import React from 'react';
import styles from './WizardStepper.module.css';

export type WizardStep = 'products' | 'customer' | 'review' | 'confirm';

interface WizardStepperProps {
  current: WizardStep;
}

const steps: { id: WizardStep; label: string }[] = [
  { id: 'products', label: 'Products' },
  { id: 'customer', label: 'Customer' },
  { id: 'review', label: 'Review' },
  { id: 'confirm', label: 'Confirm' },
];

const order: WizardStep[] = ['products', 'customer', 'review', 'confirm'];

export const WizardStepper: React.FC<WizardStepperProps> = ({ current }) => {
  const currentIdx = order.indexOf(current);

  return (
    <div className={styles.stepper}>
      {steps.map((step, idx) => {
        const isCompleted = idx < currentIdx;
        const isActive = idx === currentIdx;
        const stateClass = isActive ? styles.active : isCompleted ? styles.completed : styles.pending;

        return (
          <React.Fragment key={step.id}>
            <div className={styles.step}>
              <span className={`${styles.dot} ${stateClass}`}>
                {isCompleted ? '✓' : ''}
              </span>
              <span className={`${styles.label} ${stateClass}`}>{step.label}</span>
            </div>
            {idx < steps.length - 1 && (
              <span className={`${styles.line} ${idx < currentIdx ? styles.lineDone : ''}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
